/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * TorqueTitan API
 * Auto repair shop management API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ApiError,
  CreateCheckoutRequest,
  CreateCheckoutResponse,
  CreatePortalRequest,
  CreatePortalResponse,
  GetFreeUsageResponse,
  GetPlansResponse,
  GetSubscriptionInvoicesResponse,
  HandleSubscriptionWebhook200,
  HandleSubscriptionWebhook400,
  HandleSubscriptionWebhook500,
  HandleSubscriptionWebhookTest200,
  HandleSubscriptionWebhookTest400,
  HandleSubscriptionWebhookTest500,
  ReconcileFreeResponse,
  UpgradeSubscriptionRequest,
  UpgradeSubscriptionResponse,
  VerifyCheckoutRequest,
  VerifyCheckoutResponse,
} from './torqueTitanAPI.schemas';

import { apiFetcher } from '../apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getHandleSubscriptionWebhookUrl = () => {
  return `/subscriptions/webhook`;
};

/**
 * Handles Stripe subscription webhooks
 * @summary Stripe webhook handler
 */
export const handleSubscriptionWebhook = async (options?: RequestInit): Promise<HandleSubscriptionWebhook200> => {
  return apiFetcher<HandleSubscriptionWebhook200>(getHandleSubscriptionWebhookUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getHandleSubscriptionWebhookMutationOptions = <
  TError = HandleSubscriptionWebhook400 | HandleSubscriptionWebhook500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof handleSubscriptionWebhook>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof handleSubscriptionWebhook>>, TError, void, TContext> => {
  const mutationKey = ['handleSubscriptionWebhook'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleSubscriptionWebhook>>, void> = () => {
    return handleSubscriptionWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleSubscriptionWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleSubscriptionWebhook>>
>;

export type HandleSubscriptionWebhookMutationError = HandleSubscriptionWebhook400 | HandleSubscriptionWebhook500;

/**
 * @summary Stripe webhook handler
 */
export const useHandleSubscriptionWebhook = <
  TError = HandleSubscriptionWebhook400 | HandleSubscriptionWebhook500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof handleSubscriptionWebhook>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof handleSubscriptionWebhook>>, TError, void, TContext> => {
  return useMutation(getHandleSubscriptionWebhookMutationOptions(options), queryClient);
};
export const getHandleSubscriptionWebhookTestUrl = () => {
  return `/subscriptions/webhook-test`;
};

/**
 * Handles Stripe subscription webhooks
 * @summary Stripe subscription webhook handler (test mode)
 */
export const handleSubscriptionWebhookTest = async (
  options?: RequestInit
): Promise<HandleSubscriptionWebhookTest200> => {
  return apiFetcher<HandleSubscriptionWebhookTest200>(getHandleSubscriptionWebhookTestUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getHandleSubscriptionWebhookTestMutationOptions = <
  TError = HandleSubscriptionWebhookTest400 | HandleSubscriptionWebhookTest500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof handleSubscriptionWebhookTest>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof handleSubscriptionWebhookTest>>, TError, void, TContext> => {
  const mutationKey = ['handleSubscriptionWebhookTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleSubscriptionWebhookTest>>, void> = () => {
    return handleSubscriptionWebhookTest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HandleSubscriptionWebhookTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof handleSubscriptionWebhookTest>>
>;

export type HandleSubscriptionWebhookTestMutationError =
  | HandleSubscriptionWebhookTest400
  | HandleSubscriptionWebhookTest500;

/**
 * @summary Stripe subscription webhook handler (test mode)
 */
export const useHandleSubscriptionWebhookTest = <
  TError = HandleSubscriptionWebhookTest400 | HandleSubscriptionWebhookTest500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof handleSubscriptionWebhookTest>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof handleSubscriptionWebhookTest>>, TError, void, TContext> => {
  return useMutation(getHandleSubscriptionWebhookTestMutationOptions(options), queryClient);
};
export const getGetSubscriptionPlansUrl = () => {
  return `/subscriptions/plans`;
};

/**
 * Returns available subscription plans with prices from Stripe
 * @summary Get subscription plans
 */
export const getSubscriptionPlans = async (options?: RequestInit): Promise<GetPlansResponse> => {
  return apiFetcher<GetPlansResponse>(getGetSubscriptionPlansUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetSubscriptionPlansQueryKey = () => {
  return [`/subscriptions/plans`] as const;
};

export const getGetSubscriptionPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscriptionPlans>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubscriptionPlansQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionPlans>>> = ({ signal }) =>
    getSubscriptionPlans({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptionPlans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubscriptionPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionPlans>>>;
export type GetSubscriptionPlansQueryError = ApiError;

export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ApiError>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionPlans>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionPlans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionPlans>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionPlans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get subscription plans
 */

export function useGetSubscriptionPlans<TData = Awaited<ReturnType<typeof getSubscriptionPlans>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionPlans>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubscriptionPlansQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateSubscriptionCheckoutUrl = () => {
  return `/subscriptions/checkout`;
};

/**
 * Creates a Stripe checkout session for subscription
 * @summary Create checkout session
 */
export const createSubscriptionCheckout = async (
  createCheckoutRequest?: CreateCheckoutRequest,
  options?: RequestInit
): Promise<CreateCheckoutResponse> => {
  return apiFetcher<CreateCheckoutResponse>(getCreateSubscriptionCheckoutUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCheckoutRequest),
  });
};

export const getCreateSubscriptionCheckoutMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubscriptionCheckout>>,
    TError,
    { data?: CreateCheckoutRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSubscriptionCheckout>>,
  TError,
  { data?: CreateCheckoutRequest },
  TContext
> => {
  const mutationKey = ['createSubscriptionCheckout'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSubscriptionCheckout>>,
    { data?: CreateCheckoutRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createSubscriptionCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSubscriptionCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSubscriptionCheckout>>
>;
export type CreateSubscriptionCheckoutMutationBody = CreateCheckoutRequest | undefined;
export type CreateSubscriptionCheckoutMutationError = ApiError;

/**
 * @summary Create checkout session
 */
export const useCreateSubscriptionCheckout = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSubscriptionCheckout>>,
      TError,
      { data?: CreateCheckoutRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSubscriptionCheckout>>,
  TError,
  { data?: CreateCheckoutRequest },
  TContext
> => {
  return useMutation(getCreateSubscriptionCheckoutMutationOptions(options), queryClient);
};
export const getVerifySubscriptionCheckoutUrl = () => {
  return `/subscriptions/verify-checkout`;
};

/**
 * Retrieves a Stripe checkout session, syncs the subscription to the database, and returns the updated tier
 * @summary Verify checkout session and sync subscription
 */
export const verifySubscriptionCheckout = async (
  verifyCheckoutRequest?: VerifyCheckoutRequest,
  options?: RequestInit
): Promise<VerifyCheckoutResponse> => {
  return apiFetcher<VerifyCheckoutResponse>(getVerifySubscriptionCheckoutUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyCheckoutRequest),
  });
};

export const getVerifySubscriptionCheckoutMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifySubscriptionCheckout>>,
    TError,
    { data?: VerifyCheckoutRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifySubscriptionCheckout>>,
  TError,
  { data?: VerifyCheckoutRequest },
  TContext
> => {
  const mutationKey = ['verifySubscriptionCheckout'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifySubscriptionCheckout>>,
    { data?: VerifyCheckoutRequest }
  > = (props) => {
    const { data } = props ?? {};

    return verifySubscriptionCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifySubscriptionCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifySubscriptionCheckout>>
>;
export type VerifySubscriptionCheckoutMutationBody = VerifyCheckoutRequest | undefined;
export type VerifySubscriptionCheckoutMutationError = ApiError;

/**
 * @summary Verify checkout session and sync subscription
 */
export const useVerifySubscriptionCheckout = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifySubscriptionCheckout>>,
      TError,
      { data?: VerifyCheckoutRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof verifySubscriptionCheckout>>,
  TError,
  { data?: VerifyCheckoutRequest },
  TContext
> => {
  return useMutation(getVerifySubscriptionCheckoutMutationOptions(options), queryClient);
};
export const getCreateSubscriptionPortalUrl = () => {
  return `/subscriptions/portal`;
};

/**
 * Creates a Stripe billing portal session for subscription management
 * @summary Create billing portal session
 */
export const createSubscriptionPortal = async (
  createPortalRequest?: CreatePortalRequest,
  options?: RequestInit
): Promise<CreatePortalResponse> => {
  return apiFetcher<CreatePortalResponse>(getCreateSubscriptionPortalUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPortalRequest),
  });
};

export const getCreateSubscriptionPortalMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubscriptionPortal>>,
    TError,
    { data?: CreatePortalRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSubscriptionPortal>>,
  TError,
  { data?: CreatePortalRequest },
  TContext
> => {
  const mutationKey = ['createSubscriptionPortal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSubscriptionPortal>>,
    { data?: CreatePortalRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createSubscriptionPortal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSubscriptionPortalMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionPortal>>>;
export type CreateSubscriptionPortalMutationBody = CreatePortalRequest | undefined;
export type CreateSubscriptionPortalMutationError = ApiError;

/**
 * @summary Create billing portal session
 */
export const useCreateSubscriptionPortal = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSubscriptionPortal>>,
      TError,
      { data?: CreatePortalRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSubscriptionPortal>>,
  TError,
  { data?: CreatePortalRequest },
  TContext
> => {
  return useMutation(getCreateSubscriptionPortalMutationOptions(options), queryClient);
};
export const getReconcileFreeSubscriptionUrl = () => {
  return `/subscriptions/reconcile-free`;
};

/**
 * Creates a Stripe customer + Free metered subscription if missing. Idempotent.
 * @summary Retry Free subscription provisioning
 */
export const reconcileFreeSubscription = async (options?: RequestInit): Promise<ReconcileFreeResponse> => {
  return apiFetcher<ReconcileFreeResponse>(getReconcileFreeSubscriptionUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getReconcileFreeSubscriptionMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof reconcileFreeSubscription>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof reconcileFreeSubscription>>, TError, void, TContext> => {
  const mutationKey = ['reconcileFreeSubscription'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileFreeSubscription>>, void> = () => {
    return reconcileFreeSubscription(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReconcileFreeSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof reconcileFreeSubscription>>
>;

export type ReconcileFreeSubscriptionMutationError = ApiError;

/**
 * @summary Retry Free subscription provisioning
 */
export const useReconcileFreeSubscription = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof reconcileFreeSubscription>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof reconcileFreeSubscription>>, TError, void, TContext> => {
  return useMutation(getReconcileFreeSubscriptionMutationOptions(options), queryClient);
};
export const getGetFreeUsageUrl = () => {
  return `/subscriptions/usage`;
};

/**
 * Returns current usage + billing history for the shop on the Free plan.
 * @summary Get Free plan usage
 */
export const getFreeUsage = async (options?: RequestInit): Promise<GetFreeUsageResponse> => {
  return apiFetcher<GetFreeUsageResponse>(getGetFreeUsageUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetFreeUsageQueryKey = () => {
  return [`/subscriptions/usage`] as const;
};

export const getGetFreeUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getFreeUsage>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeUsage>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFreeUsageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreeUsage>>> = ({ signal }) =>
    getFreeUsage({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFreeUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFreeUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getFreeUsage>>>;
export type GetFreeUsageQueryError = ApiError;

export function useGetFreeUsage<TData = Awaited<ReturnType<typeof getFreeUsage>>, TError = ApiError>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeUsage>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreeUsage>>,
          TError,
          Awaited<ReturnType<typeof getFreeUsage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFreeUsage<TData = Awaited<ReturnType<typeof getFreeUsage>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeUsage>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreeUsage>>,
          TError,
          Awaited<ReturnType<typeof getFreeUsage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFreeUsage<TData = Awaited<ReturnType<typeof getFreeUsage>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Free plan usage
 */

export function useGetFreeUsage<TData = Awaited<ReturnType<typeof getFreeUsage>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreeUsage>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFreeUsageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetSubscriptionInvoicesUrl = () => {
  return `/subscriptions/invoices`;
};

/**
 * Returns up to the last 10 Stripe invoices for the authenticated shop.
 * @summary Get billing history
 */
export const getSubscriptionInvoices = async (options?: RequestInit): Promise<GetSubscriptionInvoicesResponse> => {
  return apiFetcher<GetSubscriptionInvoicesResponse>(getGetSubscriptionInvoicesUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetSubscriptionInvoicesQueryKey = () => {
  return [`/subscriptions/invoices`] as const;
};

export const getGetSubscriptionInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscriptionInvoices>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionInvoices>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubscriptionInvoicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionInvoices>>> = ({ signal }) =>
    getSubscriptionInvoices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptionInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubscriptionInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionInvoices>>>;
export type GetSubscriptionInvoicesQueryError = ApiError;

export function useGetSubscriptionInvoices<
  TData = Awaited<ReturnType<typeof getSubscriptionInvoices>>,
  TError = ApiError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionInvoices>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionInvoices>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionInvoices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubscriptionInvoices<
  TData = Awaited<ReturnType<typeof getSubscriptionInvoices>>,
  TError = ApiError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionInvoices>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionInvoices>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionInvoices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSubscriptionInvoices<
  TData = Awaited<ReturnType<typeof getSubscriptionInvoices>>,
  TError = ApiError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionInvoices>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get billing history
 */

export function useGetSubscriptionInvoices<
  TData = Awaited<ReturnType<typeof getSubscriptionInvoices>>,
  TError = ApiError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionInvoices>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSubscriptionInvoicesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpgradeSubscriptionUrl = () => {
  return `/subscriptions/upgrade`;
};

/**
 * Swaps the active subscription to a higher tier. Pro → Elite only. No coupon applied; prorated charge.
 * @summary Upgrade subscription in-place
 */
export const upgradeSubscription = async (
  upgradeSubscriptionRequest?: UpgradeSubscriptionRequest,
  options?: RequestInit
): Promise<UpgradeSubscriptionResponse> => {
  return apiFetcher<UpgradeSubscriptionResponse>(getUpgradeSubscriptionUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upgradeSubscriptionRequest),
  });
};

export const getUpgradeSubscriptionMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradeSubscription>>,
    TError,
    { data?: UpgradeSubscriptionRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradeSubscription>>,
  TError,
  { data?: UpgradeSubscriptionRequest },
  TContext
> => {
  const mutationKey = ['upgradeSubscription'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradeSubscription>>,
    { data?: UpgradeSubscriptionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return upgradeSubscription(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradeSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof upgradeSubscription>>>;
export type UpgradeSubscriptionMutationBody = UpgradeSubscriptionRequest | undefined;
export type UpgradeSubscriptionMutationError = ApiError;

/**
 * @summary Upgrade subscription in-place
 */
export const useUpgradeSubscription = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upgradeSubscription>>,
      TError,
      { data?: UpgradeSubscriptionRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof upgradeSubscription>>,
  TError,
  { data?: UpgradeSubscriptionRequest },
  TContext
> => {
  return useMutation(getUpgradeSubscriptionMutationOptions(options), queryClient);
};
